import React from "react";
import Context from "../../Context";
import { Dropdown } from "react-bootstrap";
import { FONT_SIZES, FONT_COLORS, PRESETS } from "./stylemap";

export default class ToolbarB extends React.Component {
  static contextType = Context;

  state = {
    tableSize: { rows: 1, columns: 1 },
  };

  getCurrentBlockType = () => {
    const { editorState } = this.props;
    const selection = editorState.getSelection();
    const block = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey());
    if (block) {
      return block.getType();
    }
    return null;
  };

  renderInlineButton = (style, label, title) => {
    const { onToggleInline, editorState } = this.props;
    const selection = editorState.getSelection();
    const block = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey());
    const currentStyle = block ? editorState.getCurrentInlineStyle() : null;
    return (
      <button
        title={title}
        aria-label={title}
        disabled={!this.props.editorFocused || !block}
        onMouseDown={(e) => {
          e.preventDefault();
          onToggleInline(style);
        }}
        className={`btn btn-icon ${
          currentStyle && currentStyle.has(style) ? "btn-secondary" : "btn-light"
        }`}
      >
        {label}
      </button>
    );
  };

  renderFormatPainterButton = () => {
    const active = Boolean(this.props.formatPainterActive);
    return (
      <button
        title="Формат по образцу: поставьте курсор на образец, нажмите кнопку и выделите текст назначения. Двойной щелчок — применить многократно"
        aria-label="Формат по образцу"
        aria-pressed={active}
        disabled={!this.props.editorFocused}
        onMouseDown={(e) => {
          e.preventDefault();
          this.props.onFormatPainter(e.detail > 1);
        }}
        className={`btn btn-icon ${active ? "btn-secondary" : "btn-light"}`}
      >
        <span className="fa fa-paint-brush"></span>
      </button>
    );
  };

  renderFindReplaceButton = () => (
    <button
      title="Поиск и замена (Ctrl+H)"
      aria-label="Поиск и замена"
      disabled={!this.props.editorFocused}
      onMouseDown={(event) => {
        event.preventDefault();
        this.props.onOpenFindReplace();
      }}
      className="btn btn-icon btn-light"
    >
      <span className="fa fa-search" />
    </button>
  );

  renderEntityInsertButton = (title, icon, onInsert, draggable = false) => (
    <button
      title={title}
      aria-label={title}
      draggable={draggable}
      disabled={!this.props.editorFocused || this.props.selectedEntity}
      onMouseDown={(event) => {
        event.preventDefault();
        onInsert();
      }}
      className="btn btn-icon btn-light"
    >
      <i className={icon}></i>
    </button>
  );

  insertInput = () => {
    this.props.onEntityInsert("USER_INPUT", "SEGMENTED", {
      name: "",
      kind: "text",
      minWidth: "32px",
      width: "100px",
      minHeight: "24px",
    });
  };

  insertSelect = () => {
    this.props.onEntityInsert("USER_INPUT", "SEGMENTED", {
      minWidth: "32px",
      minHeight: "24px",
      width: "100px",
      name: "",
      kind: "select",
    });
  };

  insertCheck = () => {
    this.props.onEntityInsert("USER_INPUT", "SEGMENTED", {
      name: "",
      kind: "check",
      minWidth: "26px",
      minHeight: "24px",
      list: [{ name: "", default: false }],
    });
  };

  insertLink = () => {
    this.props.onEntityInsertInline("USER_LINK", "MUTABLE", {
      linkType: "url",
      kind: "link",
      linkTo: "",
    });
  };

  renderBlockDataButton = (dataStyle, label, title) => {
    const { onToggleBlockData, editorState } = this.props;
    const selection = editorState.getSelection();
    const block = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey());
    const blockData = block ? block.getData().toJS() : {};
    const dataKey = Object.keys(dataStyle)[0];

    return (
      <button
        title={title}
        aria-label={title}
        disabled={!this.props.editorFocused || !block}
        onMouseDown={(e) => {
          e.preventDefault();
          onToggleBlockData(dataStyle);
        }}
        className={`btn btn-icon ${
          blockData[dataKey] === dataStyle[dataKey]
            ? "btn-secondary"
            : "btn-light"
        }`}
      >
        {label}
      </button>
    );
  };

  renderBlockButton = (style, label, title) => {
    const { onToggleBlock } = this.props;
    const blockType = this.getCurrentBlockType();
    return (
      <button
        title={title}
        aria-label={title}
        disabled={!this.props.editorFocused}
        onMouseDown={(e) => {
          e.preventDefault();
          onToggleBlock(style);
        }}
        className={`btn btn-icon ${
          blockType === style ? "btn-secondary" : "btn-light"
        }`}
      >
        {label}
      </button>
    );
  };

  renderFunctionButton = (id, label, title) => {
    const { onCallFunction } = this.props;
    return (
      <button
        title={title}
        aria-label={title}
        disabled={!this.props.editorFocused}
        onMouseDown={(e) => {
          e.preventDefault();
          onCallFunction(id);
        }}
        className={`btn btn-icon btn-light`}
      >
        {label}
      </button>
    );
  };

  renderTablePicker = () => {
    const { rows, columns } = this.state.tableSize;
    const maxRows = 8;
    const maxColumns = 10;
    const tableSizeLabel = `Таблица ${rows} × ${columns}`;

    return (
      <Dropdown
        className="d-inline-block table-size-dropdown"
        onToggle={(isOpen) => {
          if (!isOpen) this.setState({ tableSize: { rows: 1, columns: 1 } });
        }}
      >
        <Dropdown.Toggle
          variant="light"
          id="table-size-dropdown"
          title="Вставить таблицу: выберите размер"
          aria-label="Вставить таблицу: выберите размер"
          disabled={!this.props.editorFocused}
          onMouseDown={(event) => event.preventDefault()}
        >
          <span className="fa fa-table"></span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="table-size-picker">
          <div className="table-size-picker__label" aria-live="polite">
            {tableSizeLabel}
          </div>
          <div
            className="table-size-picker__grid"
            role="grid"
            aria-label="Выбор размера новой таблицы"
            onMouseLeave={() => this.setState({ tableSize: { rows: 1, columns: 1 } })}
          >
            {Array.from({ length: maxRows }, (_, row) =>
              Array.from({ length: maxColumns }, (_, column) => {
                const cellRows = row + 1;
                const cellColumns = column + 1;
                const selected = cellRows <= rows && cellColumns <= columns;
                const label = `Таблица ${cellRows} × ${cellColumns}`;
                return (
                  <button
                    type="button"
                    key={`${cellRows}-${cellColumns}`}
                    className={`table-size-picker__cell ${
                      selected ? "is-selected" : ""
                    }`}
                    role="gridcell"
                    aria-label={label}
                    aria-selected={selected}
                    title={label}
                    onMouseEnter={() =>
                      this.setState({
                        tableSize: { rows: cellRows, columns: cellColumns },
                      })
                    }
                    onFocus={() =>
                      this.setState({
                        tableSize: { rows: cellRows, columns: cellColumns },
                      })
                    }
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() =>
                      this.props.onCreateTable(cellRows, cellColumns)
                    }
                  />
                );
              })
            )}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderBlockDropdown = () => {
    const { editorState, onCallFunction } = this.props;
    const selection = editorState.getSelection();
    const blockType = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();

    const blocks = {
      unstyled: "Обычный абзац",
      nopadding: "Абзац без отступов",
      "header-one": "Заголовок 1",
      grid: "Ячейка сетки",
      table: "Таблица",
      cell: "Таблица",
      "header-two": "Заголовок 2",
      "header-three": "Заголовок 3",
    };

    const hideBlocks = ["grid", "table", "cell"];

    let label = blocks[blockType] || "Обычный абзац";

    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          title="Стиль абзаца и действия с таблицей"
          aria-label="Стиль абзаца и действия с таблицей"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          {label}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <div className="row px-2 py-1" style={{ width: "500px" }}>
            {blockType === "table" || blockType === "cell" ? (
              <div className="col-6">
                <label className="text-muted p-2 small">
                  Действия в таблице:
                </label>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-select-row");
                  }}
                >
                  Выделить всю строку
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-select-col");
                  }}
                >
                  Выделить весь столбец
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-autofit-col");
                  }}
                >
                  <i className="fa fa-arrows-h mr-2"></i> Подобрать ширину по тексту
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-autofit-row");
                  }}
                >
                  <i className="fa fa-arrows-v mr-2"></i> Подобрать высоту по тексту
                </Dropdown.Item>
                <hr />
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-merge-cells");
                  }}
                >
                  <i className="fa fa-compress mr-2"></i> Объединить ячейки
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-split-cell");
                  }}
                >
                  <i className="fa fa-expand mr-2"></i> Разделить ячейку
                </Dropdown.Item>
                <hr />
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-add-up");
                  }}
                >
                  <i className="fa fa-plus mr-2"></i> Строку выше
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-add-down");
                  }}
                >
                  <i className="fa fa-plus mr-2"></i> Строку ниже
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-add-left");
                  }}
                >
                  <i className="fa fa-plus mr-2"></i> Столбец слева
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-add-right");
                  }}
                >
                  <i className="fa fa-plus mr-2"></i> Столбец справа
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-remove-row");
                  }}
                >
                  <i className="fa fa-minus mr-2"></i> Удалить строку
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-remove-col");
                  }}
                >
                  <i className="fa fa-minus mr-2"></i> Удалить столбец
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-remove");
                  }}
                >
                  <i className="fa fa-times mr-2"></i> Удалить таблицу
                </Dropdown.Item>
              </div>
            ) : (
              <div className="col-6">
                <label className="text-muted p-2 small">
                  Изменить тип блока:
                </label>
                {Object.keys(blocks).map((type) => {
                  if (!hideBlocks.includes(type)) {
                    return this.renderBlockDropdownItem(
                      type,
                      blocks[type],
                      blockType
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            )}

            <div className="col-6">
              <label className="text-muted p-2 small">
                Применить набор форматирования:
              </label>
              {PRESETS.map((preset) => {
                return this.renderPresetDropdownItem(preset);
              })}
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderBlockDropdownItem = (style, label, blockType) => {
    const { onToggleBlock } = this.props;
    return (
      <Dropdown.Item
        key={style}
        onMouseDown={(e) => {
          e.preventDefault();
          onToggleBlock(style);
        }}
        className={` ${blockType === style ? "bg-secondary" : ""}`}
      >
        {label}
      </Dropdown.Item>
    );
  };
  renderPresetDropdownItem = (preset) => {
    const { onTogglePreset } = this.props;
    return (
      <Dropdown.Item
        key={preset.name}
        onMouseDown={(e) => {
          e.preventDefault();
          onTogglePreset(preset);
        }}
      >
        {preset.name}
      </Dropdown.Item>
    );
  };

  renderLinesDropdown = () => {
    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          title="Межстрочный интервал"
          aria-label="Межстрочный интервал"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          <span className="fa fa-text-height"></span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="text-center">
          <div className="btn-group ">
            {this.renderInlineButton("LH15", "1.5", "Межстрочный интервал 1,5")}
            {this.renderInlineButton("LH2", "2", "Межстрочный интервал 2")}
            {this.renderInlineButton("LH25", "2.5", "Межстрочный интервал 2,5")}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderFontsDropdown = () => {
    const { onToggleInline, editorState } = this.props;
    const currentStyle = editorState.getCurrentInlineStyle();
    let currentFont = null;

    const fonts = {
      fontArial: "Arial",
      fontTimes: "Times",
      fontComic: "Comic Sans",
      fontCourier: "Courier",
    };

    Object.keys(fonts).forEach((font) => {
      if (currentStyle.has(font)) {
        currentFont = font;
      }
    });

    if (!currentFont) currentFont = Object.keys(fonts)[0];

    let label = fonts[currentFont];

    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          title="Шрифт"
          aria-label="Шрифт"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          {label}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {Object.keys(fonts).map((font) => {
            return (
              <Dropdown.Item
                key={font}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onToggleInline(font);
                }}
                className={` ${currentFont === font ? "bg-secondary" : ""}`}
              >
                {fonts[font]}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderSizesDropdown = () => {
    const { onToggleInline, editorState } = this.props;
    const currentStyle = editorState.getCurrentInlineStyle();
    let currentSize = null;

    const sizes = FONT_SIZES;

    sizes.forEach((size) => {
      if (currentStyle.has(`fontSize${size}`)) {
        currentSize = size;
      }
    });

    if (!currentSize) currentSize = 16;

    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          title="Размер шрифта"
          aria-label="Размер шрифта"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          {currentSize}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {sizes.map((size) => {
            return (
              <Dropdown.Item
                key={size}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onToggleInline(`fontSize${size}`);
                }}
                className={` ${currentSize === size ? "bg-secondary" : ""}`}
              >
                {size}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderColorsDropdown = () => {
    const { onToggleInline, editorState } = this.props;
    const currentStyle = editorState.getCurrentInlineStyle();
    let currentColor = null;

    const colors = FONT_COLORS;

    colors.forEach((color) => {
      if (currentStyle.has(`fontColor${color}`)) {
        currentColor = color;
      }
    });

    if (!currentColor) currentColor = colors[0];

    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          title="Цвет текста"
          aria-label="Цвет текста"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          <div className="color-box" style={{ background: currentColor }}></div>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {colors.map((color) => {
            return (
              <button
                key={color}
                title={`Цвет текста: ${color}`}
                aria-label={`Цвет текста: ${color}`}
                disabled={!this.props.editorFocused}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onToggleInline(`fontColor${color}`);
                }}
                className={`btn ml-1 mt-1 btn-icon ${
                  currentColor === color ? "btn-secondary" : "btn-light"
                }`}
              >
                <div className="color-box" style={{ background: color }}></div>
              </button>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderButtons = () => {
    let blockType = this.getCurrentBlockType();
    const blockIsTable = blockType === "table" || blockType === "cell";

    return (
      <div>
        <div className="btn-group editor-toolbar__group editor-toolbar__search">
          {this.renderFindReplaceButton()}
        </div>

        <div className="btn-group editor-toolbar__group editor-toolbar__group--format">
          {this.renderFormatPainterButton()}
          {this.renderInlineButton(
            "BOLD",
            <span className="fa fa-bold"></span>,
            "Полужирный (Ctrl+B)"
          )}
          {this.renderInlineButton(
            "ITALIC",
            <span className="fa fa-italic"></span>,
            "Курсив (Ctrl+I)"
          )}
          {this.renderInlineButton(
            "UNDERLINE",
            <span className="fa fa-underline"></span>,
            "Подчёркивание (Ctrl+U)"
          )}
          {this.renderInlineButton(
            "STRIKETHROUGH",
            <span className="fa fa-strikethrough"></span>,
            "Зачёркивание"
          )}
          {this.renderInlineButton(
            "SUPERSCRIPT",
            <span className="fa fa-superscript"></span>,
            "Верхний индекс"
          )}
          {this.renderInlineButton(
            "SUBSCRIPT",
            <span className="fa fa-subscript"></span>,
            "Нижний индекс"
          )}
          {this.renderInlineButton(
            "HIGHLIGHT",
            <span className="fa fa-pencil"></span>,
            "Выделить маркером"
          )}
        </div>

        <div className="btn-group editor-toolbar__group editor-toolbar__group--font">
          {<div className="d-inline-block ">{this.renderFontsDropdown()}</div>}
          {<div className="d-inline-block  ">{this.renderSizesDropdown()}</div>}
          {<div className="d-inline-block">{this.renderColorsDropdown()}</div>}
          {<div className="d-inline-block">{this.renderBlockDropdown()}</div>}
        </div>

        <div className="btn-group editor-toolbar__group editor-toolbar__group--alignment">
          {this.renderBlockDataButton(
            { align: "left" },
            <span className="fa fa-align-left"></span>,
            "Выровнять по левому краю"
          )}
          {this.renderBlockDataButton(
            { align: "center" },
            <span className="fa fa-align-center"></span>,
            "Выровнять по центру"
          )}
          {this.renderBlockDataButton(
            { align: "justify" },
            <span className="fa fa-align-justify"></span>,
            "Выровнять по ширине"
          )}
          {this.renderBlockDataButton(
            { align: "right" },
            <span className="fa fa-align-right"></span>,
            "Выровнять по правому краю"
          )}
        </div>

        <div className="btn-group editor-toolbar__group editor-toolbar__group--list">
          {this.renderBlockButton(
            "unordered-list-item",
            <span className="fa fa-list-ul"></span>,
            "Маркированный список"
          )}
          {this.renderBlockButton(
            "ordered-list-item",
            <span className="fa fa-list-ol"></span>,
            "Нумерованный список"
          )}
        </div>

        <div className="btn-group editor-toolbar__group editor-toolbar__group--paragraph">
          {this.renderBlockButton(
            "indent",
            <span className="fa fa-indent"></span>,
            "Увеличить отступ"
          )}
          {this.renderBlockButton(
            "outdent",
            <span className="fa fa-outdent"></span>,
            "Уменьшить отступ"
          )}
          {this.renderBlockButton(
            "paragraph",
            <span className="fa fa-paragraph"></span>,
            "Параметры абзаца"
          )}
          {/*this.renderBlockButton("grid", <span className="fa fa-th"></span>)*/}
        </div>

        <div className="btn-group editor-toolbar__group editor-toolbar__group--insert editor-toolbar__group--last">
          {this.renderTablePicker()}
          {this.renderEntityInsertButton(
            "Вставить поле ввода",
            "fa fa-i-cursor",
            this.insertInput
          )}
          {this.renderEntityInsertButton(
            "Вставить выпадающий список",
            "flaticon2-sort-down",
            this.insertSelect
          )}
          {this.renderEntityInsertButton(
            "Вставить флажки",
            "flaticon2-checkmark",
            this.insertCheck,
            true
          )}
          {this.renderEntityInsertButton(
            "Вставить ссылку",
            "fa fa-link",
            this.insertLink,
            true
          )}
        </div>

        {/*<div className="d-inline-block mr-2">{this.renderLinesDropdown()}</div>*/}
      </div>
    );
  };

  render() {
    return (
      <>
        <div className="editor-toolbar">{this.renderButtons()}</div>
      </>
    );
  }
}
